const updateUserAccessBySuperadmin = {
  toastr: 'Usuário atualizado',
  toastr1: ' foi atualizado com sucesso',
  toastrError: 'Nome já cadastrado',
  toastrError: 'Insira outro nome'
};

export default updateUserAccessBySuperadmin;
